import { render, staticRenderFns } from "./ColumnParameter.vue?vue&type=template&id=e49d1bba&"
import script from "./ColumnParameter.vue?vue&type=script&lang=ts&"
export * from "./ColumnParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports